import { combineUrlAndParams } from "@nens/shared-utils";

import { FILE_NAME_KEY, FILE_REF_KEY, PATH_KEY } from "@/config/query-parameter-consts";

import { getNameFromFileId } from "./get-name-from-file-id";

export const convertFileIdToQueryParams = (id: string, ref?: string) => {
  const fileIdSplit = id.split("/");
  const fileName = fileIdSplit.pop();
  const path = fileIdSplit.join("/");

  return combineUrlAndParams("", {
    [PATH_KEY]: fileIdSplit.length ? path : undefined,
    [FILE_NAME_KEY]: fileName ? getNameFromFileId(id) : undefined,
    [FILE_REF_KEY]: ref,
  }).slice(1) /* Slice removes initial "?" */;
};
